import { render, staticRenderFns } from "./TipoLugarInteresModalEdicion.vue?vue&type=template&id=24100656&scoped=true&"
import script from "./TipoLugarInteresModalEdicion.vue?vue&type=script&lang=ts&"
export * from "./TipoLugarInteresModalEdicion.vue?vue&type=script&lang=ts&"
import style0 from "./TipoLugarInteresModalEdicion.vue?vue&type=style&index=0&id=24100656&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24100656",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('24100656', component.options)
    } else {
      api.reload('24100656', component.options)
    }
    module.hot.accept("./TipoLugarInteresModalEdicion.vue?vue&type=template&id=24100656&scoped=true&", function () {
      api.rerender('24100656', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/plataforma/TipoLugarInteresModalEdicion.vue"
export default component.exports